import { c as _c } from "react/compiler-runtime";
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { H3 } from '@algoacademy/design-system/web/typography/Heading';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
export function NoCallCard() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LightCard className="rounded-md border-contentBlue shadow-lg"><H3 className="flex items-center gap-3 text-algoBlue"><InformationCircleIcon className="h-6 w-6 text-current" />Nie zaplanowano spotkań na ten dzień</H3></LightCard>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}